import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    tabSwitchFlag: false,
    permissionErrorFlag: false,
    throttleErrorFlag: false,
    throttleRetrySeconds: null,
    dashboardEmbedData: JSON.parse(localStorage.getItem('dashboardEmbedData')) ?? null, // this will be initially null but once the data is received from the backend then will be an object

    loginErrorMessage: null,      // Stores the key for i18n translation
    shouldRedirectToLogin: false, // Flag to trigger history.push in Router.js
};

export const commonStateSlice = createSlice({
    name: "commonStates",
    initialState,
    reducers: {
        /**
         * Generic reducer to update any single state property by name.
         * Expects payload: { name: "propertyName", value: newValue }
         */
        setCommonState: (state, action) => {
            const payload = action.payload;
        
            // Check if we passed an array of updates
            if (Array.isArray(payload)) {
                payload.forEach(({ name, value }) => {
                    state[name] = value;
                });
            } else {
                // Fallback for your existing single-update calls
                const { name, value } = payload;
                state[name] = value;
            }
        },
        /**
         * Updates the throttle (Rate Limit) error state.
         * Triggered when a 429 API response is received.
         */
        setThrottleError: (state, action) => {
            state.throttleErrorFlag = action.payload.flag;
            state.throttleRetrySeconds = action.payload.retrySeconds;
        },
        /**
         * Resets the throttle error state.
         * Called after the notification duration ends to prevent repeat triggers.
         */
        clearThrottleError: (state) => {
            state.throttleErrorFlag = false;
            state.throttleRetrySeconds = null;
        },
        // eslint-disable-next-line
        reset: (state) => initialState,
    }
});


export const { setCommonState, setThrottleError, clearThrottleError, reset } = commonStateSlice.actions

export default commonStateSlice.reducer;
